import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';

type PipaSpecialOfferProps = {
  backgroundColor: any;
  backgroundImage: any;
  isPreview: any;
};

export const StyledPipaSpecialOffer = styled.div<PipaSpecialOfferProps>`
  box-sizing: border-box;
  border-radius: 12px;
  background: var(--bundle-border-color);
  font-family: var(--font-family), Arial;
  width: 100%;
  max-width: 528px;
  min-width: 343px;
  height: 200px;
  padding: 1px;
  position: relative;

  .container {
    background: ${({ backgroundImage, backgroundColor }: any) =>
      backgroundImage
        ? `url("${backgroundImage}")`
        : createGradientOrSolid(backgroundColor)};
    width: 100%;
    height: 100%;
    border-radius: 11px;
    background-size: cover;
    background-position: center;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-shadow: -1px -1px 0 #733200, 1px -1px 0 #733200, -1px 1px 0 #733200,
      1px 1px 0 #733200, 0 2px 1px #733200;
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    .products {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;

      &-container {
        display: flex;
        align-items: center;

        &--main-image {
          width: 72px;
          height: 72px;

          .image {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        &--products {
          margin-left: 12px;

          .product {
            &--main {
              display: flex;
              align-items: center;
              font-size: 32px;

              &__stroked {
                margin: 0 0 0 4px;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                text-decoration: line-through;
                color: #fff;
                text-shadow: none;
              }
            }

            &--sub-list {
              margin-top: 4px;
              font-size: 16px;
              display: flex;
              align-items: center;

              &--item {
                display: flex;
                align-items: center;
                margin-right: 8px;
                &:last-child {
                  margin-right: 0;
                }

                .sub-image {
                  width: 24px;
                  height: 24px;
                  margin-right: 4px;

                  .image {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                  }
                }
              }
            }
          }
        }
      }
    }

    .price {
      height: 32px;
      min-height: 32px;
      position: relative;
      border-bottom-left-radius: 11px;
      border-bottom-right-radius: 11px;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-shadow: 0 1px 2px #000;
      margin-top: auto;

      .timeLeft {
        height: 32px;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-shadow: 0 1px 2px #000;
        top: 0;
        left: 8px;
        display: flex;
        align-items: center;
      }

      .availability {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        position: absolute;
        right: 8px;
        text-shadow: 0 1px 2px #000;
        top: 0;
        display: flex;
        align-items: center;
        height: 32px;
      }

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background: var(--bundle-border-color);
      }
    }
  }

  @media only screen and (min-width: 1280px) {
    height: ${({ isPreview }: any) => (isPreview ? '200px' : '268px')};

    .container {
      .products {
        &-container {
          &--main-image {
            height: ${({ isPreview }: any) => (isPreview ? '72px' : '112px')};
            width: ${({ isPreview }: any) => (isPreview ? '72px' : '112px')};
          }

          &--products {
            .product {
              &--main {
                font-size: ${({ isPreview }: any) =>
                  isPreview ? '32px' : '36px'};
              }

              &--sub-list {
                font-size: ${({ isPreview }: any) =>
                  isPreview ? '16px' : '20px'};
              }
            }
          }
        }
      }

      .price {
        height: ${({ isPreview }: any) => (isPreview ? '32px' : '40px')};
        min-height: ${({ isPreview }: any) => (isPreview ? '32px' : '40px')};
        font-size: ${({ isPreview }: any) => (isPreview ? '16px' : '20px')};

        .availability,
        .timeLeft {
          height: ${({ isPreview }: any) => (isPreview ? '32px' : '40px')};
        }
      }
    }
  }
`;
